import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'

export default function DialogoErrorReoptimizacion({ error, onClose }) {
  return (
    <Dialog open={!!error} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: 'error.main' }}>Error en la reoptimización</DialogTitle>
      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          <Typography variant="body2">
            Se produjo un error al intentar reoptimizar la planificación.
          </Typography>
        </Alert>
        {error && (
          <Typography variant="body2" sx={{ fontFamily: 'monospace', mt: 1, color: 'error.dark' }}>
            {error.split('\n').filter(Boolean).at(-1)}
          </Typography>
        )}
        {error && (
          <Accordion
            sx={{
              boxShadow: 'none',
              '&:before': { display: 'none' },
              bgcolor: 'transparent',
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                px: 0,
                minHeight: 40,
                '& .MuiAccordionSummary-content': { my: 0.5 },
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Ver detalles técnicos
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pt: 0 }}>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: 'monospace',
                  fontSize: '0.8rem',
                  whiteSpace: 'pre-wrap',
                  bgcolor: 'rgba(0,0,0,0.05)',
                  p: 1.5,
                  borderRadius: 1,
                  wordBreak: 'break-word',
                }}
              >
                {error}
              </Typography>
            </AccordionDetails>
          </Accordion>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
